import { css } from '@emotion/core'

export const styles = {
  side: css`
    flex: 1;
    padding: 10px;

    display: flex;
    flex-direction: column;
  `,
}
